import { render, staticRenderFns } from "./subMenu.vue?vue&type=template&id=edd0471a&"
import script from "./subMenu.vue.ts?vue&type=script&lang=ts&"
export * from "./subMenu.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports